import { render, staticRenderFns } from "./ProductFormPreviewModal.vue?vue&type=template&id=dbc663d4&"
import script from "./ProductFormPreviewModal.vue?vue&type=script&lang=js&"
export * from "./ProductFormPreviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports